import { Api, DisplayType, HorizontalAlignment, ModelRow, StringUtil, UserSettings } from "@mcleod/core";
import { ImageName } from "@mcleod/images";
import {
    Button, ClickEvent, Component, DataSourceExecutionEvent, Image, Label, Panel, TableRow, TableRowDisplayEvent
} from "@mcleod/components";
import { AutogenLayoutSmsQuickInfo } from "./autogen/AutogenLayoutSmsQuickInfo";
import { SmsUtility } from "./SmsUtility";

export class SmsQuickInfo extends AutogenLayoutSmsQuickInfo {
    private messageCount: number = 0;
    private messageLimit: number = 0;
    private rowCount: number = 0;
    private _movementId: string;
    private _driverName: string;
    private _carrierId: string;

    private smsFilterDirection = "";
    async onLoad() {
        await this.sourceCurrentUserPowerbroker.search({user_id: UserSettings.getUserId()})
        if(this.sourceCurrentUserPowerbroker.activeRow !== undefined) {
            this.messageLimit = this.sourceCurrentUserPowerbroker.activeRow.get("sms_message_limit") === undefined ? 5 : this.sourceCurrentUserPowerbroker.activeRow.get("sms_message_limit");
            this.smsFilterDirection = this.sourceCurrentUserPowerbroker.activeRow.get(("message_visibility")) == "U" ? "I" : "A";
        }else{
            this.messageLimit = 5;
            this.smsFilterDirection = "U";
        }
    }

    sourceCarrierDriverMessageBeforeExecution(event: DataSourceExecutionEvent) {
        if(this.smsFilterDirection == "I"){
            event.filter.direction = 'I';
            event.filter.message_read = 'N';
        }
    }


    tableSmsQuickInfoOnRowDisplay(event: TableRowDisplayEvent) {
        const totalMessageCount = this.sourceCarrierDriverMessage?.summaryData?.get("total_messages");
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data;
        this.messageCount += 1;
        this.rowCount++;
        if(this.rowCount <= this.messageLimit) {
            this.setGlobalFields(modelRow);
            const components = this.getTableRowComponents(tableRow);

            components.buttonResend.addMouseEnterListener(event => {
                const button = event.target as Button;
                button.backgroundColor = 'primary';
                button.color = 'McLeodWhite';
            } );

            components.buttonReply.addMouseEnterListener(event => {
                const button = event.target as Button;
                button.backgroundColor = 'primary';
                button.color = 'McLeodWhite';
            } );

            components.buttonResend.addMouseLeaveListener(event => {
                const button = event.target as Button;
                button.color = 'default.lighter'
                button.backgroundColor = '';
            } );

            components.buttonReply.addMouseLeaveListener(event => {
                const button = event.target as Button;
                button.color = 'default.lighter'
                button.backgroundColor = '';
            } );

            components.sendDate.text = this.formatDate(modelRow.get("send_date"));

            if (StringUtil.equalsIgnoreCase(modelRow.get("direction"), "O")) {
                this.handleOutgoingMessage(components, modelRow);
            } else {
                this.handleIncomingMessage(components, modelRow);
            }

            if (StringUtil.equalsIgnoreCase(modelRow.get("message_read"), "N") && StringUtil.equalsIgnoreCase(modelRow.get("direction"), "I")) {
                this.btnMarkAllRead.visible = true;
            }

            this.updateVisibilityBasedOnMessageCount(totalMessageCount);
            if (totalMessageCount > this.messageLimit) {
                this.buttonViewAll.visible = true;
            }
        }else {
            this.updateVisibilityBasedOnMessageCount(totalMessageCount);
            tableRow.visible = false;
        }
    }

   private formatDate(sendDate: string): string | null {
       try {
           if (!sendDate || sendDate.trim() === "") {
               return "";
           }

           const inputFormat: Intl.DateTimeFormatOptions = {
               year: 'numeric',
               month: '2-digit',
               day: '2-digit',
               hour: 'numeric',
               minute: 'numeric',
               second: 'numeric'
           };

           const date: Date = new Date(sendDate);
           const outputFormat: Intl.DateTimeFormatOptions = {
               year: 'numeric',
               month: '2-digit',
               day: '2-digit',
               hour: 'numeric',
               minute: 'numeric',
               hour12: true
           };
           let formattedDate: string = date.toLocaleString('en-US', outputFormat);
           formattedDate = formattedDate.replace(',', '');
           return formattedDate;
       } catch (error) {
           console.error(error);
           return null;
       }
    }

    private getTableRowComponents(tableRow: TableRow) {
        return {
            labelMessageText: tableRow.findComponentById("labelMessageText") as Label,
            labelDirectionText: tableRow.findComponentById("labelDirectionText") as Label,
            labelMessageStatus: tableRow.findComponentById("labelMessageStatus") as Label,
            labelDirection: tableRow.findComponentById("labelDirection") as Label,
            directionImage: tableRow.findComponentById("directionImage") as Image,
            messageRead: tableRow.findComponentById("labelMessageRead") as Label,
            labelMarkStatus: tableRow.findComponentById("labelMarkStatus") as Label,
            buttonReply: tableRow.findComponentById("buttonReply") as Button,
            buttonResend: tableRow.findComponentById("buttonResend") as Button,
            readStatusImage: tableRow.findComponentById("readStatusImage") as Image,
            media: tableRow.findComponentById("labelMediaInfo") as Label,
            mediaPanel: tableRow.findComponentById("mediaPanel") as Panel,
            sendDate: tableRow.findComponentById("labelSendDate") as Label,
        };
    }

    private handleOutgoingMessage(components: any, modelRow: ModelRow<any>) {
        const {
            labelDirectionText,
            directionImage,
            labelMarkStatus,
            buttonReply,
            buttonResend,
            readStatusImage,
            labelMessageStatus,
            mediaPanel,
            sendDate
        } = components;

        labelDirectionText.text = "Outgoing";
        labelMarkStatus.visible = false;
        buttonReply.visible = false;
        mediaPanel.visible = false;
        readStatusImage.visible = false;
        buttonResend.visible = this.displayResendButtonForMessages(modelRow) || this.displayResendButtonForScheduledMessages(modelRow) || this.displayResendButtonForRecurringMessages(modelRow);
        sendDate.visible = true;


        if (StringUtil.equalsIgnoreCase(modelRow.get("status"),"F")) {
            this.setOutgoingErrorState(labelDirectionText, directionImage);
        } else {
            this.setOutgoingSuccessState(labelDirectionText, directionImage, modelRow.get("status"),modelRow.get("cancelled_scheduled_message"),modelRow.get("scheduled_message")
                ,modelRow.get("recurrence_enabled"), modelRow.get("scheduled_send_date"),modelRow.get("recurrence_frequency"),modelRow.get("send_date"));
        }
    }

    private setOutgoingErrorState(labelDirectionText: Label, directionImage: Image) {
        labelDirectionText.text += " - Error";
        labelDirectionText.color = "error";
        directionImage.name = ImageName.messagesOutgoingOutlined;
        directionImage.color = "error";
    }

    private setOutgoingSuccessState(labelDirectionText: Label, directionImage: Image, messageStatus: string, cancelledScheduledMessage: boolean, scheduledMessage: string,
                                    recurrenceEnabled: string, scheduledSendDate: string, recurrenceFrequency: number,sendDate: string) {
        if(StringUtil.isEmptyString(messageStatus)){
            labelDirectionText.color = "primary";
        }else {
            if(cancelledScheduledMessage){
                labelDirectionText.color = "primary";
                labelDirectionText.text = "Canceled";
                directionImage.name = ImageName.messagesOutgoingFilled;
                directionImage.color = labelDirectionText.color;
            }else if(StringUtil.equalsIgnoreCase("Y", scheduledMessage) && StringUtil.equalsIgnoreCase("Y", recurrenceEnabled)){
                labelDirectionText.color = "primary";
                labelDirectionText.text = "Recurring";
                directionImage.name = ImageName.recurringMessage;
                directionImage.color = labelDirectionText.color;
                if (sendDate === undefined) {
                    const frequencyMessage = (recurrenceFrequency === 1) ? "hour" : recurrenceFrequency + " hour(s)";
                    const tooltipText = "Message will be sent every " + frequencyMessage + " starting at " + this.formatDate(scheduledSendDate);
                    directionImage.tooltip = tooltipText;
                    labelDirectionText.tooltip = tooltipText;
                } else {
                    const frequencyMessage = (recurrenceFrequency === 1) ? "hour" : recurrenceFrequency + " hour(s)";
                    const tooltipText = "Message will be sent every " + frequencyMessage + " starting at " + this.formatDate(scheduledSendDate);
                    directionImage.tooltip = tooltipText
                    labelDirectionText.tooltip = tooltipText;
                }

            }else if(StringUtil.equalsIgnoreCase("Y", scheduledMessage) && StringUtil.equalsIgnoreCase("N", recurrenceEnabled)){
                labelDirectionText.color = "primary";
                labelDirectionText.text = "Scheduled";
                directionImage.name = ImageName.clock;
                directionImage.color = labelDirectionText.color;
                if (sendDate === undefined) {
                    const tooltipText = "Message scheduled to be sent at " + this.formatDate(scheduledSendDate);
                    directionImage.tooltip = tooltipText;
                    labelDirectionText.tooltip = tooltipText;
                }
            }else {
                if(messageStatus === "C"){
                    labelDirectionText.color = "primary";
                }else {
                    labelDirectionText.color = messageStatus === "P" ? "primary" : "success";
                }
                directionImage.name = ImageName.messagesOutgoingFilled;
                directionImage.color = labelDirectionText.color;
            }
        }
    }

    private handleIncomingMessage(components: any, modelRow: ModelRow<any>) {
        const {
            labelDirectionText,
            labelMarkStatus,
            buttonReply,
            directionImage,
            buttonResend,
            readStatusImage,
            sendDate
        } = components;

        labelDirectionText.text = "Incoming";
        labelDirectionText.color = "primary";
        directionImage.color = "primary";
        labelMarkStatus.visible = true;
        buttonReply.visible = true;
        readStatusImage.visible = true;
        buttonResend.visible = false;
        sendDate.visible = true;
        this.setIncomingMessageState(components,modelRow);
    }

    private setIncomingMessageState(components: any, modelRow: ModelRow<any>) {
        const {labelMarkStatus, readStatusImage, directionImage, mediaPanel,labelMessageText,labelDirectionText} = components;
        const mediaMessageUrl = modelRow.get("media_message_url");

        if (StringUtil.equalsIgnoreCase(modelRow.get("message_read"),"Y")) {
            labelMarkStatus.text = "Mark Unread";
            readStatusImage.name = ImageName.envelopeUnread;
            readStatusImage.color = "primary";
            readStatusImage.marginTop = "";
            directionImage.name = ImageName.messagesIncomingFilled;
            labelDirectionText.fontBold = false;
        } else {
            labelMarkStatus.text = "Mark as Read";
            readStatusImage.name = ImageName.envelopeRead;
            readStatusImage.color = "primary";
            readStatusImage.marginTop = "10px";
            directionImage.name = ImageName.messagesIncomingOutlined;
            labelDirectionText.fontBold = true;
        }

        if (mediaMessageUrl) {
            mediaPanel.visible = true;
            const message = "View ";
            const splitStrings: string[] = mediaMessageUrl.split(", ");

            for (let i = 0; i < splitStrings.length; i++) {
                const mediaName: string[] = splitStrings[i].split('/');
                const result: string = mediaName[mediaName.length - 1];

                const label = new Label({
                    text: `${message}Image ${i + 1}`,
                    color: "primary.light",
                    wrap: true,
                    displayType: DisplayType.STRING,
                    align: HorizontalAlignment.LEFT,
                    padding:0,
                    margin: 0,
                    imageProps: { name: ImageName.designer_attachment, color: "primary", align: HorizontalAlignment.LEFT, marginLeft: 0 },
                    onClick: (event) => {
                        SmsUtility.labelMediaMessageOnClick(event, result);
                    }
                });

                mediaPanel.add(label);
            }
        }
    }


    private updateVisibilityBasedOnMessageCount(totalMessageCount: string) {
        this.panelHeader.visible = this.labelMessageCountText.visible = this.labelMessageCount.visible = this.messageCount > 1;
        if(parseInt(totalMessageCount) < parseInt(String(this.messageLimit))){
            this.labelMessageCount.text = totalMessageCount + "/" + totalMessageCount
        }else {
            this.labelMessageCount.text = this.messageLimit + "/" + totalMessageCount;
        }

    }

    buttonResendOnClick(event: ClickEvent) {
        const row = TableRow.getContainingTableRow(event.target as Component);
        const modelRow = row?.data;
        SmsUtility.showSendSmsMessageSlideout(SmsUtility.setLayoutProps(modelRow, false,false));
    }

    buttonReplyOnClick(event: ClickEvent) {
        const row: TableRow = TableRow.getContainingTableRow(event.target as Component);
        const modelRow = row?.data;
        SmsUtility.showSendSmsMessageSlideout(SmsUtility.setLayoutProps(modelRow, false,true));
    }

    async buttonViewAllOnClick(event: ClickEvent) {
        const movementId = this._movementId;
        const newRowData = await this.tableSmsQuickInfo._createNewRowData();
        newRowData.set("movement_id", movementId);
        SmsUtility.showSendSmsMessageSlideout(SmsUtility.setLayoutProps(newRowData, false,false));
    }

    buttonMarkAllReadOnClick(event: ClickEvent) {
        const movementId = this._movementId;
        this.updateMessageStatus(null, true, movementId);
    }

    markStatusOnClick(event: ClickEvent) {
        const messageStatus = event.target as Label;
        const tableRow = TableRow.getContainingTableRow(messageStatus);
        const modelRow = tableRow.data;
        const messageId = modelRow.get("parent_row_id");
        const messageRead = messageStatus.text === "Mark as Read";
        this.updateMessageStatus(messageId, messageRead,null);
    }

    private updateMessageStatus(messageId: string, messageRead: boolean, movementId: string) {
        Api.post("lme/powerbroker/update-message-read", {
            message_id: messageId,
            message_read: messageRead,
            movement_id: movementId
        });
    }

    private setGlobalFields(modelRow: ModelRow<any>) {
        this._movementId = modelRow.get("movement_id");
        this._driverName = modelRow.get("driver_name");
        this._carrierId = modelRow.get("carrier_id");


    }

    private displayResendButtonForScheduledMessages(modelRow: ModelRow<any>) {
        return !StringUtil.isEmptyString(modelRow.get("scheduled_send_date")) && StringUtil.equalsIgnoreCase(modelRow.get("message_sent"),"Y");

    }

    private displayResendButtonForMessages(modelRow: ModelRow<any>) {
        return StringUtil.isEmptyString(modelRow.get("scheduled_send_date"));

    }

    private displayResendButtonForRecurringMessages(modelRow: ModelRow<any>) {
        return StringUtil.equalsIgnoreCase(modelRow.get("recurrence_enabled"),"Y") && !StringUtil.isEmptyString(modelRow.get("next_scheduled_send_date"));
    }
}
